var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2071 18.293C19.8166 17.9024 19.1834 17.9024 18.7929 18.293C18.4024 18.6835 18.4024 19.3167 18.7929 19.7072L20.2071 18.293ZM22.2929 23.2071C22.6834 23.5977 23.3165 23.5977 23.7071 23.2071C24.0976 22.8166 24.0976 22.1835 23.7071 21.7929L22.2929 23.2071ZM18.7929 19.7072L22.2929 23.2071L23.7071 21.7929L20.2071 18.293L18.7929 19.7072ZM11 18.5C6.58172 18.5 3 14.9183 3 10.5H1C1 16.0228 5.47715 20.5 11 20.5V18.5ZM19 10.5C19 14.9183 15.4183 18.5 11 18.5V20.5C16.5228 20.5 21 16.0228 21 10.5H19ZM11 2.5C15.4183 2.5 19 6.08172 19 10.5H21C21 4.97715 16.5228 0.5 11 0.5V2.5ZM11 0.5C5.47715 0.5 1 4.97715 1 10.5H3C3 6.08172 6.58172 2.5 11 2.5V0.5Z",
    fill: "#424040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d983f2f55c68fa330b3f1a9396a86b5c.svg";
export { ForwardRef as ReactComponent };